import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from 'react-apollo'

import 'react-tippy/dist/tippy.css'
import 'index.css'
import 'react-perfect-scrollbar/dist/css/styles.css'

import { unregister } from 'registerServiceWorker'
import { $ } from 'utils'
import { client } from 'config'
import App from './App'


ReactDOM.render(
  $(ApolloProvider, { client },
    $(BrowserRouter, $(App))),
  document.getElementById('root'))

  unregister()



// WEBPACK FOOTER //
// ./src/index.js